import { Guid } from "@/Common/Models/Guid";
import { FormType } from "@/Patient/Models/Forms/FormTypeEnum";
import { GenericForm } from "@/Patient/Models/Forms/GenericForm";

class RadPdfForm {
    public PatientFormId: string;
    public LastUpdateDate: Date;
    public RadDocumentId: string;
    public RadDocumentTag: string;
    public FormName: string;
    public EncounterId: Guid;
    public EncounterConsultationDate: Date;
    public IsPdfVersionConflictDetected: boolean;
    public FormId: string;

    constructor(fields?: Partial<RadPdfForm>) {
        Object.assign(this, fields);
    }

    public toGenericForm(): GenericForm {
        let form = new GenericForm();
        form.formName = this.FormName;
        form.formId = this.FormId;
        form.formType = FormType.PDF;
        return form;
    }
}

export { RadPdfForm };
